import { render, staticRenderFns } from "./UpgradeEditDialog.vue?vue&type=template&id=0f6b7f6a&scoped=true"
import script from "./UpgradeEditDialog.vue?vue&type=script&lang=js"
export * from "./UpgradeEditDialog.vue?vue&type=script&lang=js"
import style0 from "./UpgradeEditDialog.vue?vue&type=style&index=0&id=0f6b7f6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6b7f6a",
  null
  
)

export default component.exports